import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import styled from "styled-components";
import Fade from '@material-ui/core/Fade';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import MetricSelection from './MetricSelection';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import { min, isEmpty } from 'lodash';
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from '@loanbossinc/component-library';


const MetricsSelected = styled.div`
  && {
    font-family: Work Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    padding-left:20px;
    margin:0;
  }
`
const Description = styled.div`
  /* Work Sans / 14 Regular */
  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;


  /* Text / Black */
  color: #000000;
  padding-bottom:20px;
`;

const Spacer = styled.div`
  flex-grow:1;
`;

const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`;

const StyledDialogActions = styled(DialogActions)`&& {
    justify-content: flex-end;
}`;

const StyledPrimaryButton = styled(PrimaryButton)`&&&{
  margin-top: 16px;
  margin-left: 24px;
  margin-right: 24px;
  margin-bottom: 24px;
}`;

const StyledSecondaryButton = styled(SecondaryButton)`&&&{
  margin-top: 16px;
  margin-bottom: 24px;
}`;


class SelectMetricsStep extends React.Component {
  state = {
    shouldShowError: false
  }

  selectionErrorMessageUnderMax = {
    metric: `You must choose ${this.maxCount} metrics for your top bar.`,
    column: `You must choose ${this.maxCount} columns.`
  }
  selectionErrorMessageOverMax = {
    metric: `You have already selected ${this.maxCount} metrics.`,
    column: `You have already selected ${this.maxCount} columns.`
  }
  dialogDescription = {
    metric: `Select the (${this.maxCount}) metrics you would like to see displayed at the top of your screen`,
    column: `Select the (${this.maxCount}) columns you would like to see displayed on this table`
  }

  get maxCount() {
    let maxCount = this.props.maxCount || 6;
    const availableMetrics = this.props.metrics.length;
    return min([maxCount, availableMetrics])
  }
  get dialogType() { return this.props.isMetric ? "metric" : "column" }
  close = () => { this.props.handleClose(); }

  next = (activeStep) => {
    const { metrics } = this.props;
    if (this.getSelectedMetricCount() < this.maxCount) {
      this.setState({
        shouldShowError: true,
        selectionErrorMessage: this.selectionErrorMessageUnderMax[this.dialogType]
      })
      return null;
    }
    this.props.handleNext(activeStep, metrics)
  }

  getSelectedMetricCount = () => {
    return this.props.metrics.filter(x => x.isSelected).length;
  }

  isElementSelected = (elementId) => {
    const { metrics } = this.props;
    let index = metrics.findIndex(x => x.screenElementId === elementId);
    return metrics[index].isSelected;
  }

  onToggle = (elementId) => {
    if (!this.isElementSelected(elementId) && this.getSelectedMetricCount() == this.maxCount) {
      this.setState({
        shouldShowError: true,
        selectionErrorMessage: this.selectionErrorMessageOverMax[this.dialogType]
      })
    } else {
      this.setState({ shouldShowError: false })
      this.props.onToggle(elementId);
    }
  }
  sortByTitleAlphabetically = (a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  }
  renderMetrics = metrics => (
    <GridList cellHeight='auto' cols={3} spacing={4}>
      {
        metrics.sort(this.sortByTitleAlphabetically).map(x => (
          <GridListTile key={x.screenElementId}>
            <MetricSelection
              metric={x}
              toggle={this.onToggle}>
            </MetricSelection>
          </GridListTile>
        ))
      }
    </GridList>
  );

  render() {
    const { activeStep, handleNext, metrics } = this.props;
    let { shouldShowError, selectionErrorMessage } = this.state;

    if (isEmpty(metrics))
      return null;
    return (
      <React.Fragment>
        <DialogContent>
          <Description>{this.dialogDescription[this.dialogType]}</Description>
          {this.renderMetrics(metrics)}
        </DialogContent>
        <StyledDialogActions>
          <MetricsSelected>{this.getSelectedMetricCount()}/{this.maxCount} Selected</MetricsSelected>
          <Fade in={shouldShowError}>
            <Error>{selectionErrorMessage}</Error>
          </Fade>
          <Spacer></Spacer>
          <Fragment>
            <StyledSecondaryButton label="Cancel" size={ButtonSizeOptions.sm} onClick={this.close} />
            <StyledPrimaryButton label="Next" size={ButtonSizeOptions.sm} onClick={() => this.next(activeStep)} />
          </Fragment>
        </StyledDialogActions>
      </React.Fragment>
    );
  }
}

export default SelectMetricsStep;
